import { useState } from "react";
import { AddServiceDto } from "src/api/request/requestService";

export interface UseServiceSelectionStateReturn {
  // Selected services
  selectedServices: (number | string)[];
  setSelectedServices: React.Dispatch<React.SetStateAction<(number | string)[]>>;
  selectedServicesData: any[];
  setSelectedServicesData: React.Dispatch<React.SetStateAction<any[]>>;
  selectedHistoryServices: (number | string)[];
  setSelectedHistoryServices: React.Dispatch<React.SetStateAction<(number | string)[]>>;
  
  // Services list
  services: AddServiceDto[];
  setServices: React.Dispatch<React.SetStateAction<AddServiceDto[]>>;
  
  // Loading & processing states
  loadingServices: boolean;
  setLoadingServices: React.Dispatch<React.SetStateAction<boolean>>;
  isServiceProcessing: boolean;
  setIsServiceProcessing: React.Dispatch<React.SetStateAction<boolean>>;
  isSubmittingToPatient: boolean;
  setIsSubmittingToPatient: React.Dispatch<React.SetStateAction<boolean>>;
  
  // Edit modal state
  editModalOpen: boolean;
  setEditModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  editRow: any | null;
  setEditRow: React.Dispatch<React.SetStateAction<any | null>>;
  
  // HUV filter
  huv: boolean;
  setHuv: React.Dispatch<React.SetStateAction<boolean>>;
  
  // Pending service queue for batch processing
  pendingServiceQueue: {
    serviceId: number | string;
    explicitService?: any;
    associatedHistoryId?: number | string;
  }[];
  setPendingServiceQueue: React.Dispatch<React.SetStateAction<{
    serviceId: number | string;
    explicitService?: any;
    associatedHistoryId?: number | string;
  }[]>>;
}

/**
 * Custom hook for managing service selection states.
 * This hook only manages state - handlers are defined in the parent component.
 */
export function useServiceSelectionState(): UseServiceSelectionStateReturn {
  // Selected services
  const [selectedServices, setSelectedServices] = useState<(number | string)[]>([]);
  const [selectedServicesData, setSelectedServicesData] = useState<any[]>([]);
  const [selectedHistoryServices, setSelectedHistoryServices] = useState<(number | string)[]>([]);
  
  // Services list
  const [services, setServices] = useState<AddServiceDto[]>([]);
  
  // Loading & processing states
  const [loadingServices, setLoadingServices] = useState<boolean>(false);
  const [isServiceProcessing, setIsServiceProcessing] = useState<boolean>(false);
  const [isSubmittingToPatient, setIsSubmittingToPatient] = useState<boolean>(false);
  
  // Edit modal state
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editRow, setEditRow] = useState<any | null>(null);
  
  // HUV filter
  const [huv, setHuv] = useState(false);
  
  // Pending service queue for batch processing
  const [pendingServiceQueue, setPendingServiceQueue] = useState<{
    serviceId: number | string;
    explicitService?: any;
    associatedHistoryId?: number | string;
  }[]>([]);

  return {
    // Selected services
    selectedServices,
    setSelectedServices,
    selectedServicesData,
    setSelectedServicesData,
    selectedHistoryServices,
    setSelectedHistoryServices,
    
    // Services list
    services,
    setServices,
    
    // Loading & processing states
    loadingServices,
    setLoadingServices,
    isServiceProcessing,
    setIsServiceProcessing,
    isSubmittingToPatient,
    setIsSubmittingToPatient,
    
    // Edit modal state
    editModalOpen,
    setEditModalOpen,
    editRow,
    setEditRow,
    
    // HUV filter
    huv,
    setHuv,
    
    // Pending service queue
    pendingServiceQueue,
    setPendingServiceQueue,
  };
}
